import { createTheme as g } from "../../_mixins/use-theme.js";
import n from "../../_styles/common/light.js";
import h from "../../button/styles/light.js";
import u from "../../progress/styles/light.js";
import { changeColor as f } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function x(e) {
  const {
    iconColor: t,
    primaryColor: i,
    errorColor: o,
    textColor2: m,
    successColor: l,
    opacityDisabled: a,
    actionColor: d,
    borderColor: r,
    hoverColor: s,
    lineHeight: p,
    borderRadius: C,
    fontSize: c
  } = e;
  return {
    fontSize: c,
    lineHeight: p,
    borderRadius: C,
    draggerColor: d,
    draggerBorder: `1px dashed ${r}`,
    draggerBorderHover: `1px dashed ${i}`,
    itemColorHover: s,
    itemColorHoverError: f(o, {
      alpha: 0.06
    }),
    itemTextColor: m,
    itemTextColorError: o,
    itemTextColorSuccess: l,
    itemIconColor: t,
    itemDisabledOpacity: a,
    itemBorderImageCardError: `1px solid ${o}`,
    itemBorderImageCard: `1px solid ${r}`
  };
}
const b = g({
  name: "Upload",
  common: n,
  peers: {
    Button: h,
    Progress: u
  },
  self: x
}), T = b;
export {
  T as default,
  x as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/styles/light.js
// module id = 1726
// module chunks = 41